<po-page-default p-title="Ferramentas Gerais - Contabilidade" [p-breadcrumb]="breadcrumb">
  <div class="page-summary">
    <div class="page-summary-icon"><span class="an an-toolbox"></span></div>
    <div class="page-summary-text">
      <p class="po-font-subtitle">Ferramentas de Processamento</p>
      <p class="page-summary-hint">
        Utilize as ferramentas abaixo para correção de CFOPs em arquivos XML e normalização de arquivos SPED.
      </p>
    </div>
  </div>

  <form #form="ngForm">

    <!-- Correção de CFOPs -->
    <div class="tool-section po-mt-3">
      <div class="tool-section-header">
        <i class="an an-wrench"></i>
        <span>Correção de CFOPs</span>
      </div>
      <div class="tool-section-body">
        <div class="tool-description">
          <p>Selecione um arquivo <strong>.zip</strong> para realizar o processamento. O sistema irá executar um
            <strong>"De - Para"</strong> com as regras já configuradas para ajustar os arquivos.</p>
        </div>

        <div class="upload-area" (click)="zipInput.click()">
          <input #zipInput id="upload-zip" type="file" accept=".zip" (change)="testXml($event)" class="upload-input-hidden" />
          <div class="upload-area-icon"><i class="an an-upload-simple"></i></div>
          <p class="upload-area-label">Arraste ou clique para selecionar o arquivo</p>
          <p class="upload-area-hint">Formato aceito: <strong>.zip</strong></p>
          <span class="upload-area-btn"><i class="an an-folder-open po-mr-1"></i> Escolher Arquivo</span>
        </div>

        <div class="tool-footer">
          <div class="tool-footer-link">
            <po-link p-label="Configurar Regras (CT-e)" p-url="/regras-cte"></po-link>
          </div>
          <div class="tool-notice">
            <i class="an an-info po-mr-2"></i>
            Depois de processado, o relatório estará disponível para download no próprio navegador. Dependendo da quantidade de arquivos, esse processo pode levar alguns segundos.
          </div>
        </div>
      </div>
    </div>

    <!-- Normalização de Arquivos SPED -->
    <div class="tool-section po-mt-4">
      <div class="tool-section-header">
        <i class="an an-file-text"></i>
        <span>Normalização de Arquivos SPED</span>
      </div>
      <div class="tool-section-body">
        <div class="tool-description">
          <p>Selecione um arquivo <strong>.txt</strong> para realizar o processamento. O sistema irá executar uma
            limpeza em caracteres especiais do arquivo.</p>
        </div>

        <div class="upload-area" (click)="txtInput.click()">
          <input #txtInput id="upload-txt" type="file" accept=".txt" (change)="corrigeTxt($event)" class="upload-input-hidden" />
          <div class="upload-area-icon"><i class="an an-upload-simple"></i></div>
          <p class="upload-area-label">Arraste ou clique para selecionar o arquivo</p>
          <p class="upload-area-hint">Formato aceito: <strong>.txt</strong></p>
          <span class="upload-area-btn"><i class="an an-folder-open po-mr-1"></i> Escolher Arquivo</span>
        </div>

        <div class="tool-footer">
          <div class="tool-notice">
            <i class="an an-info po-mr-2"></i>
            Depois de processado, o arquivo estará disponível para download no próprio navegador, e dependendo do tamanho do arquivo, esse processo pode levar alguns segundos.
          </div>
        </div>
      </div>
    </div>

  </form>
